function helperStringLowerCase (str) {
  return str.toLowerCase()
}

module.exports = helperStringLowerCase



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperStringLowerCase.js
// module id = 311
// module chunks = 98